import * as React from "react"

import { cn } from "@/lib/utils"
import { Input } from "@/components/ui/input"

const InputGroup = React.forwardRef(function InputGroup({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      data-slot="input-group"
      className={cn(
        "flex h-9 items-stretch rounded-3xl border border-input bg-input/50 transition-[color,box-shadow,background-color] focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/30",
        className
      )}
      {...props}
    />
  )
})

const InputGroupAddon = React.forwardRef(function InputGroupAddon({ className, ...props }, ref) {
  return (
    <span
      ref={ref}
      data-slot="input-group-addon"
      className={cn(
        "flex shrink-0 items-center px-3 text-sm text-muted-foreground select-none",
        className
      )}
      {...props}
    />
  )
})

const InputGroupInput = React.forwardRef(function InputGroupInput({ className, ...props }, ref) {
  return (
    <Input
      ref={ref}
      data-slot="input-group-input"
      className={cn(
        "h-full grow rounded-none bg-transparent px-0 focus-visible:border-transparent focus-visible:ring-0",
        className
      )}
      {...props}
    />
  )
})

export { InputGroup, InputGroupAddon, InputGroupInput }
